@if (tariff) {
    @if (!bookingServiceConfig) {
        <p class="text-error"
           translate="error.configuration.noBookingConfiguration"></p>
    } @else {
        <div class="content-container bg-white-no-shadow">
            <div class="btn-bar" #buttonBar>
                @if (selectedBooking && BookingUtils.canEditOrCancelBooking(selectedBooking, bookingServiceConfig, isExploitant)) {
                    <button
                        class="btn btn-outline-danger"
                        (click)="confirmAndDeleteBooking()"
                        translate="common.cancelBooking">
                    </button>
                }
                @if (selectedBooking && selectedBooking.recurring) {
                    <button
                        class="btn btn-outline-danger"
                        (click)="openPartialCancelFormModal()"
                        translate="common.cancelBookingPartially">
                    </button>
                }
                @if (!isFormOpen && selectedBooking && BookingUtils.canEditOrCancelBooking(selectedBooking, bookingServiceConfig, isExploitant)) {
                    <button
                        class="btn btn-primary"
                        translate="bookings.update"
                        (click)="isFormOpen = true;">
                    </button>
                }
                @if (!isFormOpen) {
                    <button
                        class="btn btn-primary"
                        translate="bookings.add"
                        (click)="initFormWithStartDate()">
                    </button>
                }
            </div>
            <!-- Booking details view -->
            @if (!isFormOpen && selectedBooking) {
                <app-booking-viewer
                    [booking]="selectedBooking"
                    [isExploitant]="isExploitant"
                    [bookingServiceConfig]="bookingServiceConfig"
                    [customerId]="customerId"
                    [serviceId]="serviceId"></app-booking-viewer>
            }
            @if (isFormOpen && (selectedDate || selectedBooking || selectedSlot)) {
                <app-booking-form
                    [availableItems]="items"
                    [bookingServiceConfig]="bookingServiceConfig"
                    [isExploitant]="isExploitant"
                    [serviceId]="serviceId"
                    [selectedBooking]="selectedBooking"
                    [selectedItemId]="selectedItemId"
                    [selectedDate]="selectedDate"
                    [selectedSlot]="selectedSlot"
                    [tariff]="tariff"
                    [customerId]="customerId"
                    (closeForm)="closeForm()"
                    (refreshCalendar)="refreshCalendar()"></app-booking-form>
            }
            <!-- Calendar for free booking mode -->
            @if (bookingServiceConfig.bookingMode === BookingMode.Free) {
                <app-free-booking-calendar #freeBookingCalendarComponent
                                           [serviceId]="serviceId"
                                           [customerId]="customerId"
                                           [bookingServiceConfig]="bookingServiceConfig"
                                           [items]="items"
                                           [isExploitant]="isExploitant"
                                           (selectDate)="selectDate($event)"
                                           (selectItemId)="selectItem($event)"
                                           (selectBooking)="selectBooking($event)"></app-free-booking-calendar>
            } @else if (bookingServiceConfig.bookingMode === BookingMode.Slots) {
                <!-- Calendar for slots booking mode -->
                <app-slots-calendar #slotsCalendarComponent
                                    [customerId]="customerId"
                                    [serviceId]="serviceId"
                                    [bookingServiceConfig]="bookingServiceConfig"
                                    [items]="items"
                                    [isExploitant]="isExploitant"
                                    (selectSlot)="selectSlot($event)"
                                    (selectItemId)="selectItem($event)"></app-slots-calendar>
            }
        </div>
    }
}
